import type {LazyStore} from "@atg-shared/lazy-store";
import {runLazySaga} from "@atg-shared/lazy-store";
import {fetchSaga} from "@atg-shared/fetch-redux";
import cleanupApolloCacheOnLogoutSaga from "./domain/cleanupApolloCacheOnLogoutSaga";

export default function rootSaga(store: LazyStore<any, any>) {
    runLazySaga(store, fetchSaga);
    runLazySaga(store, cleanupApolloCacheOnLogoutSaga);
}
